import React from 'react';
import _ from 'lodash';

const Pagination = ({
  pageCount,
  currentPage,
  setCurrentPage,
  scrollToTop
}) => {

  console.log(currentPage)
  const pageNumbers = _.range(pageCount + 1).slice(1);

  const nextPage = () => {
    if (currentPage !== pageCount) setCurrentPage(currentPage + 1);
  };
  const prevPage = () => {
    if (currentPage !== 1) setCurrentPage(currentPage - 1);
  };

  return (
    <div onClick={scrollToTop}>
      <ul className="pagination justify-content-center">
        {currentPage != 1?
        <li className="page-item">
          <a className="page-link" onClick={prevPage} href="#">
            {'<'}
          </a>
        </li>
        :""}
        {pageNumbers.map(pgNumber => (
          <li
            key={pgNumber}
            className={`page-item ${
              currentPage == pgNumber ? 'active' : ''
            } `}>
            <a
              onClick={() => {setCurrentPage(pgNumber)}}
              className="page-link"
              href="#">
              {pgNumber}
            </a>
          </li>
        ))}
        {currentPage != pageCount?
        <li className="page-item">
          <a className="page-link" onClick={nextPage} href="#">
            {'>'}
          </a>
        </li>
        :""}
      </ul>
    </div>
  );
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/Newsroom/AllArticles/Pagination.js